import { render } from "./CareerDetailsPage.vue?vue&type=template&id=513561e8&ts=true"
import script from "./CareerDetailsPage.vue?vue&type=script&lang=ts"
export * from "./CareerDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__